import { render } from "./CookiePopupComponent.vue?vue&type=template&id=237235c3"
import script from "./CookiePopupComponent.vue?vue&type=script&lang=js"
export * from "./CookiePopupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__